import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API, urlBase } from "../APICalls";
import provinces from "../assets/provinces";

export default function Form() {
  var { token } = useParams();

  const [raffleForm, setRaffleForm] = useState(null);
  const [retrievingRaffleFormError, setRetrievingRaffleFormError] =
    useState(false);

  const [submitFormStatus, setSubmitFormStatus] = useState(null);

  useEffect(() => {
    API.GetCustomerForm(token).then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          setRaffleForm(data);
        });
      } else {
        setRetrievingRaffleFormError(true);
      }
    });
  }, []);

  const orderedProvinces = provinces.sort((a, b) => {
    return a.code.localeCompare(b.code);
  });

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [addressName, setAddressName] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [addressOther, setAddressOther] = useState("");
  const [addressPostalCode, setAddressPostalCode] = useState("");
  const [addressCity, setAddressCity] = useState("");
  const [addressProvince, setAddressProvince] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);

  const [formErrors, setFormErrors] = useState(null);

  const submitForm = (e) => {
    const checkedFormErrors = {};
    //validate name: required, max 50 length
    if (name == "") checkedFormErrors.name = "El nombre es obligatorio";
    else if (name.length > 50)
      checkedFormErrors.name = "El nombre no puede tener más de 50 caracteres";

    //validate surname: required, max 50 length
    if (surname == "")
      checkedFormErrors.surname = "Los apellidos son obligatorios";
    else if (surname.length > 50)
      checkedFormErrors.surname =
        "Los apellidos no pueden tener más de 50 caracteres";

    //validate email: required, max 512 length, valid email with regex
    if (email == "") checkedFormErrors.email = "El email es obligatorio";
    else if (email.length > 512)
      checkedFormErrors.email = "El email no puede tener más de 512 caracteres";
    else if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
      checkedFormErrors.email = "El email no es válido";

    //validate phone: required, spanish phone number (starting in 6,7,8,9 and 9 digits)
    if (phone == "") checkedFormErrors.phone = "El teléfono es obligatorio";
    else if (!phone.match(/^[6-9]\d{8}$/))
      checkedFormErrors.phone = "El teléfono no es válido";

    //validate nationalId: required, spanish NIF or spanish NIE
    if (nationalId == "")
      checkedFormErrors.nationalId = "El NIF/NIE es obligatorio";
    else if (!nationalId.match(/^([0-9]{8}[A-Z])|([XYZ][0-9]{7}[A-Z])$/))
      checkedFormErrors.nationalId =
        "El NIF/NIE no es válido (ej. 12345678A o X1234567A)";

    //validate addressName: required, max 150 length
    if (addressName == "")
      checkedFormErrors.addressName = "El nombre de la vía es obligatorio";
    else if (addressName.length > 150)
      checkedFormErrors.addressName =
        "El nombre de la vía no puede tener más de 150 caracteres";

    //validate addressNumber: required, max 16 length, number only
    if (addressNumber == "")
      checkedFormErrors.addressNumber = "El número es obligatorio";
    else if (addressNumber.length > 16)
      checkedFormErrors.addressNumber =
        "El número no puede tener más de 16 caracteres";
    else if (!addressNumber.match(/^[0-9]+$/))
      checkedFormErrors.addressNumber = "El número no es válido";

    //validate addressOther: max 50 length, not required
    if (addressOther.length > 50)
      checkedFormErrors.addressOther =
        "El resto de la dirección no puede tener más de 50 caracteres";

    //validate addressPostalCode: required, starting from 00 to 52, 5 digits total
    if (addressPostalCode == "")
      checkedFormErrors.addressPostalCode = "El código postal es obligatorio";
    else if (!addressPostalCode.match(/^(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}$/))
      checkedFormErrors.addressPostalCode = "El código postal no es válido";

    //validate addressCity: required, max 100 length
    if (addressCity == "")
      checkedFormErrors.addressCity = "La ciudad es obligatoria";
    else if (addressCity.length > 100)
      checkedFormErrors.addressCity =
        "La ciudad no puede tener más de 100 caracteres";

    //validate addressProvince: required, max 50 length
    if (addressProvince == "")
      checkedFormErrors.addressProvince = "La provincia es obligatoria";
    else if (addressProvince.length > 50)
      checkedFormErrors.addressProvince =
        "La provincia no puede tener más de 50 caracteres";

    //validate acceptTerms: required
    if (!acceptTerms)
      checkedFormErrors.acceptTerms =
        "Debes aceptar los términos y condiciones para participar";

    setFormErrors(checkedFormErrors);

    console.log(Object.keys(checkedFormErrors).length);

    if (Object.keys(checkedFormErrors).length > 0) return;

    console.log("Form is valid");

    //TODO: Post form

    API.SubmitCustomerForm(
      raffleForm.Id,
      raffleForm.RaffleId,
      name,
      surname,
      email,
      phone,
      nationalId,
      addressName,
      addressNumber,
      addressOther,
      addressPostalCode,
      addressCity,
      addressProvince
    ).then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          setSubmitFormStatus("success");
        });
      } else {
        setSubmitFormStatus("server-error");
      }
    });
  };

  document.getElementsByTagName("body")[0].classList.remove("login-page");
  document.getElementsByTagName("body")[0].classList.remove("sidebar-mini");

  if (raffleForm == null && retrievingRaffleFormError == false)
    return <div>Loading...</div>;

  if (retrievingRaffleFormError) {
    return (
      <>
        <div className="content" style={{ margin: "5%" }}>
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="login-logo">
                <img
                  src={"/LOGO_LEBEN_RAFFLE.png"}
                  style={{ height: 100 }}
                  alt="LebenRaffle"
                />
              </div>
            </div>
          </div>
          <div className="error-page">
            <h2 className="headline text-danger"> 400</h2>
            <div className="error-content">
              <h3>
                <i className="fas fa-exclamation-triangle text-danger"></i>{" "}
                Oops! Lo sentimos, ha pasado el plazo que tenías para enviarnos
                tus datos desde que se notifica el premio.
              </h3>
              <p>¡Te esperamos en el siguiente!</p>
            </div>
          </div>
        </div>
        <footer
          className="main-footer"
          style={{ marginLeft: 0, marginTop: "25%" }}
        >
          <div className="container">
            <div className="float-right d-none d-sm-block">
              <b>Version</b> 1.7.4
            </div>
            <strong>
              Copyright © {new Date().getFullYear()}{" "}
              <a href="https://grupoleben.com" target="_blank">
                Grupo Leben Servicios de Marketing
              </a>
              .
            </strong>{" "}
            Todos los derechos reservados.
          </div>
        </footer>
      </>
    );
  }

  if (submitFormStatus == "success") {
    return (
      <>
        <div className="content" style={{ margin: "5%" }}>
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="login-logo">
                <img
                  src={"/LOGO_LEBEN_RAFFLE.png"}
                  style={{ height: 100 }}
                  alt="LebenRaffle"
                />
              </div>
            </div>
          </div>
          <div className="error-page">
            <h2 className="headline text-success"> {":)"}</h2>
            <div className="error-content">
              <h3>
                <i className="fas fa-info-circle text-success"></i>{" "}
                ¡Enhorabuena! Hemos recibido tus datos correctamente
              </h3>
              <p>
                En breve nos pondremos en contacto contigo para enviarte tu
                premio.
              </p>
            </div>
          </div>
        </div>
        <footer
          className="main-footer"
          style={{ marginLeft: 0, marginTop: "25%" }}
        >
          <div className="container">
            <div className="float-right d-none d-sm-block">
              <b>Version</b> 1.7.4
            </div>
            <strong>
              Copyright © {new Date().getFullYear()}{" "}
              <a href="https://grupoleben.com" target="_blank">
                Grupo Leben Servicios de Marketing
              </a>
              .
            </strong>{" "}
            Todos los derechos reservados.
          </div>
        </footer>
      </>
    );
  }

  if (submitFormStatus == "server-error") {
    return (
      <>
        <div className="content" style={{ margin: "5%" }}>
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="login-logo">
                <img
                  src={"/LOGO_LEBEN_RAFFLE.png"}
                  style={{ height: 100 }}
                  alt="LebenRaffle"
                />
              </div>
            </div>
          </div>
          <div className="error-page">
            <h2 className="headline text-danger"> 500</h2>
            <div className="error-content">
              <h3>
                <i className="fas fa-exclamation-triangle text-danger"></i>{" "}
                Oops! Ha ocurrido un error al guardar tus datos
              </h3>
              <p>
                Inténtalo de nuevo más tarde. Si el error persiste, ponte en
                contacto con el organizador del sorteo
              </p>
            </div>
          </div>
        </div>
        <footer
          className="main-footer"
          style={{ marginLeft: 0, marginTop: "25%" }}
        >
          <div className="container">
            <div className="float-right d-none d-sm-block">
              <b>Version</b> 1.7.4
            </div>
            <strong>
              Copyright © {new Date().getFullYear()}{" "}
              <a href="https://grupoleben.com" target="_blank">
                Grupo Leben Servicios de Marketing
              </a>
              .
            </strong>{" "}
            Todos los derechos reservados.
          </div>
        </footer>
      </>
    );
  }

  return (
    <>
      <div
        className="content"
        style={{ backgroundColor: "rgb(244, 246, 249)" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="login-logo">
                <img
                  className="img-fluid"
                  src={"/LOGO_LEBEN_RAFFLE.png"}
                  style={{ maxHeight: 100 }}
                  alt="LebenRaffle"
                />
              </div>

              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h5 className="card-title">
                    <strong>{raffleForm.Title}</strong>
                  </h5>
                </div>

                <div className="card-body">
                  {raffleForm?.ImageFile && (
                    <div className="col-12 d-flex justify-content-center align-items-center">
                      <img
                        src={
                          urlBase + "/api/PublicFile/" + raffleForm.ImageFile
                        }
                        className="img-fluid"
                        style={{ maxHeight: 600 }}
                      />
                    </div>
                  )}
                  <p className="card-text">{raffleForm.Description}</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label for="name">Nombre *</label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.name ? " is-invalid" : "")
                          }
                          id="name"
                          name="name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.name}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label for="surname">Apellidos *</label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.surname ? " is-invalid" : "")
                          }
                          id="surname"
                          name="surname"
                          value={surname}
                          onChange={(e) => setSurname(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.surname}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label for="phone">Teléfono *</label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.phone ? " is-invalid" : "")
                          }
                          id="phone"
                          name="phone"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.phone}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label for="nationalId">
                          NIF/NIE *{" "}
                          <code>
                            (sin espacios ni guiones y letras en mayúscula)
                          </code>
                        </label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.nationalId ? " is-invalid" : "")
                          }
                          id="nationalId"
                          name="nationalId"
                          value={nationalId}
                          onChange={(e) =>
                            setNationalId(
                              e.target.value
                                .toUpperCase()
                                .replace("-", "")
                                .replace(" ", "")
                            )
                          }
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.nationalId}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label for="email">Email *</label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.email ? " is-invalid" : "")
                          }
                          id="email"
                          name="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.email}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-9">
                      <div className="form-group">
                        <label for="addressName">Nombre de la Vía *</label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.addressName ? " is-invalid" : "")
                          }
                          id="addressName"
                          name="addressName"
                          value={addressName}
                          onChange={(e) => setAddressName(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.addressName}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label for="addressNumber">Número *</label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.addressNumber ? " is-invalid" : "")
                          }
                          id="addressNumber"
                          name="addressNumber"
                          value={addressNumber}
                          onChange={(e) => setAddressNumber(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.addressNumber}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label for="addressOther">
                          Resto (Piso, puerta...)
                        </label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.addressOther ? " is-invalid" : "")
                          }
                          id="addressOther"
                          name="addressOther"
                          value={addressOther}
                          onChange={(e) => setAddressOther(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.addressOther}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label for="addressPostalCode">Código Postal *</label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.addressPostalCode ? " is-invalid" : "")
                          }
                          id="addressPostalCode"
                          name="addressPostalCode"
                          value={addressPostalCode}
                          onChange={(e) => setAddressPostalCode(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.addressPostalCode}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label for="addressCity">Ciudad *</label>
                        <input
                          type="text"
                          className={
                            "form-control " +
                            (formErrors?.addressCity ? " is-invalid" : "")
                          }
                          id="addressCity"
                          name="addressCity"
                          value={addressCity}
                          onChange={(e) => setAddressCity(e.target.value)}
                        />
                        <span className="error invalid-feedback">
                          {formErrors?.addressCity}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="form-group">
                        <label>Provincia *</label>
                        <select
                          className={
                            "form-control " +
                            (formErrors?.addressProvince ? " is-invalid" : "")
                          }
                          name="addressProvince"
                          value={addressProvince}
                          onChange={(e) => setAddressProvince(e.target.value)}
                        >
                          <option value="">Selecciona una provincia</option>
                          {orderedProvinces.map((province) => (
                            <option value={province.label}>
                              {province.label}
                            </option>
                          ))}
                        </select>
                        <span className="error invalid-feedback">
                          {formErrors?.addressProvince}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className={
                          "custom-control-input " +
                          (formErrors?.acceptTerms ? " is-invalid" : "")
                        }
                        id="acceptTerms"
                        name="acceptTerms"
                        checked={acceptTerms}
                        onChange={(e) => setAcceptTerms(e.target.checked)}
                      />
                      <label className="custom-control-label" for="acceptTerms">
                        Confirmo que acepto el premio derivado de este sorteo
                      </label>
                    </div>

                    {formErrors?.acceptTerms && (
                      <span
                        className="error invalid-feedback"
                        style={{ display: "inline" }}
                      >
                        {formErrors?.acceptTerms}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <button
                      type="submit"
                      className="btn btn-primary btn-block"
                      onClick={submitForm}
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="main-footer" style={{ marginLeft: 0 }}>
        <div className="container">
          <div className="float-right d-none d-sm-block">
            <b>Version</b> 1.7.4
          </div>
          <strong>
            Copyright © {new Date().getFullYear()}{" "}
            <a href="https://grupoleben.com" target="_blank">
              Grupo Leben Servicios de Marketing
            </a>
            .
          </strong>{" "}
          Todos los derechos reservados.
        </div>
      </footer>
    </>
  );
}
